import { userIdSchema } from "@nimble/datamodel/types/userId";
export type { UserId } from "@nimble/datamodel/types/userId";
import { JobSeekingStatus } from "@nimble/core-client/types";
import { z } from "zod";

export const userSchema = z.object({
  id: z.number().transform(String).pipe(userIdSchema),
  email: z.email(),
  name: z.string(),
  first_name: z.string(),
  last_name: z.string(),

  date_joined: z.string(),
  last_login: z.string().nullable(),

  intercom_hmac: z.string(),
  is_hijacked: z.boolean().default(false),

  preference: z
    .object({
      job_seeking_status: z
        .enum([...Object.values(JobSeekingStatus)])
        .nullable(),
    })
    .nullable(),
  profile: z
    .object({
      user_type: z.number(),
      address_city: z.string(),
      address_state: z.string(),
      district: z
        .object({
          id: z.number(),
          name: z.string(),
          parent_organization: z.string().nullable(),
        })
        .nullable(),
    })
    .nullable(),
});

export type User = z.infer<typeof userSchema>;
